import { MinimalLayout } from '@/components/layouts/MinimalLayout'
import { Navbar } from '@/components/nav/Navbar'
import { OrgToolsTable } from '@/components/OrgToolsTable/OrgToolsTable'
import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogPortal,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog'
import { Input } from '@/components/ui/input'
import {
  useCreateTool,
  useDeleteTool,
  useListToolsQuery,
  useUpdateTool,
} from '@/services/queries/tools'
import { PlusIcon } from '@heroicons/react/24/outline'
import { useState } from 'react'

export const ToolsPage = () => {
  const { data: tools, isLoading } = useListToolsQuery()
  const { mutate: deleteTool } = useDeleteTool()
  const { mutate: updateTool } = useUpdateTool()

  return (
    <MinimalLayout>
      <Navbar>
        <div className="flex items-center space-x-4 h-10 py-8 w-full" />
      </Navbar>
      <div className="relative mt-4 py-4 px-2 w-full rounded-xl bg-white">
        <div className="flex items-center justify-between">
          <h1 className="text-normal font-semibold tracking-[-0.015em] text-zinc-950 mx-10">
            Tools Library
          </h1>
          <AddToolButton />
        </div>
        <OrgToolsTable
          tools={tools}
          isLoading={isLoading}
          onUpdate={updateTool}
          onDelete={deleteTool}
        />
      </div>
    </MinimalLayout>
  )
}

const AddToolButton = () => {
  const [isOpen, setIsOpen] = useState(false)
  const [name, setName] = useState('')

  const { mutate: createTool } = useCreateTool()

  const handleCreate = () => {
    createTool({ name })
    setName('')
    setIsOpen(false)
  }

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger asChild>
        <Button className="mr-4">
          <PlusIcon className="h-4" />
          <span>Add New Tool</span>
        </Button>
      </DialogTrigger>
      <DialogPortal>
        <DialogContent
          ariaLabel="Add new tool dialog"
          className="max-w-lg min-h-0"
        >
          <DialogHeader>
            <DialogTitle>Add New Tool</DialogTitle>
          </DialogHeader>
          <div className="flex flex-row gap-4 mt-8">
            <Input
              placeholder="Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  handleCreate()
                }
              }}
            />
            <Button onClick={handleCreate} disabled={!name}>
              Add
            </Button>
          </div>
        </DialogContent>
      </DialogPortal>
    </Dialog>
  )
}
